import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { AuthFailedReason, } from '../hosted-web-content-auth-sdk';
import { BaseAuthenticationMessageHandler } from './base-auth-message-handler';
import { callServiceAndFormulateLogMessageResult } from './messageHandlingUtils';
/**
 * Responsible for handling authentication related message requests.
 */
var AuthenticationWindowMessageHandler = /** @class */ (function (_super) {
    __extends(AuthenticationWindowMessageHandler, _super);
    function AuthenticationWindowMessageHandler(appAuthSdkHost, authenticationService, telemetryService) {
        var _this = _super.call(this, appAuthSdkHost, authenticationService, telemetryService) || this;
        _this.appAuthSdkHost = appAuthSdkHost;
        _this.authenticationService = authenticationService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    AuthenticationWindowMessageHandler.prototype.initHandlers = function () {
        _super.prototype.initHandlers.call(this);
        this.registerHandler(SdkMessageTypes.authentication.notifySuccess, this.handleNotifySuccess);
        this.registerHandler(SdkMessageTypes.authentication.notifyFailure, this.handleNotifyFailure);
    };
    AuthenticationWindowMessageHandler.prototype.handleNotifySuccess = function (_event, result) {
        this.appAuthSdkHost.closeWindow();
        this.appAuthSdkHost.stopAuthWindowMonitor();
        return callServiceAndFormulateLogMessageResult(this.authenticationService.notifySuccess, result);
    };
    AuthenticationWindowMessageHandler.prototype.handleNotifyFailure = function (_event, reason) {
        this.appAuthSdkHost.closeWindow();
        this.appAuthSdkHost.stopAuthWindowMonitor();
        return callServiceAndFormulateLogMessageResult(this.authenticationService.notifyFailure, reason, AuthFailedReason.Other);
    };
    return AuthenticationWindowMessageHandler;
}(BaseAuthenticationMessageHandler));
export { AuthenticationWindowMessageHandler };
//# sourceMappingURL=auth-window-message-handler.js.map